export default __webpack_public_path__ + "static/media/index-last1.378e7b9e.png";